import { render, staticRenderFns } from "./RecePayable.vue?vue&type=template&id=4c06d60f&"
import script from "./RecePayable.vue?vue&type=script&lang=js&"
export * from "./RecePayable.vue?vue&type=script&lang=js&"
import style0 from "./RecePayable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports